export default __webpack_public_path__ + "static/media/github.bfe22a7c.svg";